export const galleryItems = [
  { type: "image", src: "/Award/1.jpg", title: "Campus Event" },
  {
    type: "video",
    src: "https://www.youtube.com/watch?v=bo217CuaiAE",
    title: "Workshop",
  },
  { type: "image", src: "/Award/2.jpg", title: "Lab Session" },
  { type: "image", src: "/Award/3.png", title: "Lab Session" },
  { type: "image", src: "/Award/4.jpg", title: "Lab Session" },
  { type: "image", src: "/Award/5.jpg", title: "Lab Session" },
  { type: "image", src: "/Award/6.jpg", title: "Lab Session" },
  {
    type: "video",
    src: "https://www.youtube.com/embed/9bZkp7q19f0",
    title: "Seminar",
  },
];
